import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getAirwaySelector } from '../selectors'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { INumberPadProps } from '../../../../components/numberPad/NumberPad.component'
import { IToggle } from '../../../../components/toggle/Toggle.component'
import { ISingleSelectProps } from '../../../../components/singleSelect/SingleSelect.component'

export function* setAction() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { inputRows } = procedureState
  const { action } = airwayState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === AirwayConstants.SET_ORAL_PHARYNGEAL_AIRWAY) {
        input.hidden = String(action?.id) === 'Bag Valve Mask' ? false : true
        if (input.hidden) {
          const opaProps: IToggle = input.props as IToggle
          opaProps.isChecked = false
        }
      }
      if (input.key === AirwayConstants.SET_VIA) {
        input.hidden = String(action?.name) === 'Oxygen' ? false : true
        if (input.hidden) {
          const viaProps: ISingleSelectProps = input.props as ISingleSelectProps
          viaProps.selectedOption = null
        }
      }
      if (input.key === AirwayConstants.SET_SIZE) {
        input.hidden = String(action?.name) === 'Oxygen' ? true : false
        if (input.hidden) {
          const sizeProps: INumberPadProps = input.props as INumberPadProps
          sizeProps.values = []
        }
      }
      if (input.key === AirwayConstants.SET_PRESSURE) {
        input.hidden = String(action?.name) === 'CPAP' ? false : true
        if (input.hidden) {
          const pressureProps: INumberPadProps = input.props as INumberPadProps
          pressureProps.values = []
        }
      }
      if (input.key === AirwayConstants.SET_INSPIRATORY_PRESSURE) {
        input.hidden = String(action?.name) === 'BiPAP' ? false : true
        if (input.hidden) {
          const iPressureProps: INumberPadProps = input.props as INumberPadProps
          iPressureProps.values = []
        }
      }
      if (input.key === AirwayConstants.SET_EXPIRATORY_PRESSURE) {
        input.hidden = String(action?.name) === 'BiPAP' ? false : true
        if (input.hidden) {
          const ePressureProps: INumberPadProps = input.props as INumberPadProps
          ePressureProps.values = []
        }
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionSaga() {
  yield takeLatest([AirwayConstants.SET_ACTION, AirwayConstants.SET_UPDATE_INPUT_ROWS], setAction)
}
